const i18n = {
  'en-US': {
    slogan: 'Make every part traceable'
  },
  'zh-CN': {
    slogan: '让每个零件都可追溯'
  }
};
export default i18n;